var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#1264A3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42611 10.7025L4.48078 8.39052C4.41876 8.32763 4.34486 8.27769 4.26337 8.24361C4.18189 8.20952 4.09444 8.19197 4.00611 8.19197C3.91779 8.19197 3.83034 8.20952 3.74885 8.24361C3.66737 8.27769 3.59347 8.32763 3.53145 8.39052C3.46854 8.45341 3.41863 8.52809 3.38458 8.61028C3.35053 8.69246 3.33301 8.78055 3.33301 8.86952C3.33301 8.95848 3.35053 9.04657 3.38458 9.12875C3.41863 9.21094 3.46854 9.28562 3.53145 9.34852L5.94478 12.1325C6.00724 12.1958 6.08166 12.2461 6.16371 12.2805C6.24577 12.3148 6.33383 12.3325 6.42278 12.3325C6.51173 12.3325 6.59979 12.3148 6.68185 12.2805C6.76391 12.2461 6.83832 12.1958 6.90078 12.1325L12.4674 4.82452C12.5304 4.76162 12.5803 4.68694 12.6143 4.60475C12.6484 4.52257 12.6659 4.43448 12.6659 4.34552C12.6659 4.25655 12.6484 4.16846 12.6143 4.08628C12.5803 4.00409 12.5304 3.92941 12.4674 3.86652C12.4054 3.80363 12.3315 3.75369 12.25 3.71961C12.1686 3.68552 12.0811 3.66797 11.9928 3.66797C11.9045 3.66797 11.817 3.68552 11.7355 3.71961C11.654 3.75369 11.5801 3.80363 11.5181 3.86652L6.42611 10.7025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.c16ee8ea8de80832c1a13330cf61acfe.svg";
export { ForwardRef as ReactComponent };